// IMPORTANT Autogenerated file
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { StampePartecipoDto } from '@ideapa/common-dto';
import { SelectItem } from '@ideapa/common-interfaces';
import { map, Observable } from 'rxjs';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class StampePartecipoApiClient extends BaseCRUDApiClient<StampePartecipoDto> {
  baseUrl = this.config.apiEndpoint + '/stampe-partecipo';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getTassonomie() {
    return this.http.get<SelectItem[]>(`${this.baseUrl}/tassonomie`);
  }

  downloadBdap(tassonomia: string, fileName: string): Observable<ArrayBuffer> {
    // console.log('tassonomia: ', tassonomia);
    // console.log('fileName: ', fileName);
    return this.http
      .post(
        this.baseUrl + '/download-bdap',
        {
          tassonomia: tassonomia,
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  downloadMovimenti(body: {
    idProspetto: number | null;
    idStruttura: number | null;
  }) {
    return this.http
      .post(`${this.baseUrl}/download-movimenti`, body, {
        responseType: 'arraybuffer',
      })
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  downloadDocxNotaIntegrativa(
    idTemplate: number | null
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-docx-nota-integrativa',
        {
          idTemplate: idTemplate,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }
}
